import React, { useEffect } from "react";
import "./lifestack-output.css";
import { useGameStore } from "./store/gameStore";
import SetupScreen from "./components/setup/SetupScreen";
import GameBoard from "./components/board/GameBoard";
import EndGameScreen from "./components/endgame/EndGameScreen";
import { LanguageProvider } from "./i18n/LanguageContext";

export default function LifeStack() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3964949168915513";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <LanguageProvider>
      <LifeStackInner />
    </LanguageProvider>
  );
}

function LifeStackInner() {
  const { appPhase, phase } = useGameStore();
  if (appPhase === "setup") return <SetupScreen />;
  if (phase === "GAME_OVER") return <EndGameScreen />;
  return <GameBoard />;
}
